import {connect} from 'react-redux';

import MediaOrderImportContainer from './MediaOrderImportContainer';
import {importMediaOrderAction} from './Redux/MediaOrderImportActions';

export const mapDispatch = {
    importMedia: importMediaOrderAction,
};

export default connect(null, mapDispatch)(MediaOrderImportContainer);
